import {
  SEARCH_CITIES_START,
  SEARCH_CITIES_SUCCESS,
  SEARCH_CITIES_ERROR,
  SEARCH_NEARBYCITIES_START,
  SEARCH_NEARBYCITIES_SUCCESS,
  SEARCH_NEARBYCITIES_ERROR
} from "../actions/cities.actions";

const INITIAL_STATE = {
  cities: [],
  isLoading: false,
  nearbyCities: []
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SEARCH_CITIES_START:
      return { ...state, isLoading: true };
    case SEARCH_CITIES_SUCCESS:
      return { ...state, cities: action.data.data, isLoading: false };
    case SEARCH_CITIES_ERROR:
      return { ...state, error: action.error, isLoading: false };
    case SEARCH_NEARBYCITIES_START:
      return { ...state, isLoading: true };
    case SEARCH_NEARBYCITIES_SUCCESS:
      return { ...state, nearbyCities: action.data.data, isLoading: false };
    case SEARCH_NEARBYCITIES_ERROR:
      return { ...state, error: action.error, isLoading: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cities.reducer.js